// Lib
import React, { ReactElement } from 'react';

// Components
import SheetContainer, { CloseButton, Content, Header, Heading, Sheet } from '../../mobile/structural/sheet';
import { NotificationsListProps } from '../../workspace/header/workspaceToolsHeader/notifications/popup/NotificationsList';
import NotificationsContent from '../../workspace/header/workspaceToolsHeader/notifications/NotificationsContent';
import NotificationsPopupTabbedContent from '../../workspace/header/workspaceToolsHeader/notifications/popup/NotificationsPopupTabbedContent';

// Utils
import useSheet from '../../mobile/structural/sheet/hooks/useSheet';

// Types
import { SheetId } from '../structural/sheet/sheetTypes';

import './MobileNotificationsSheet.scss';

const MobileNotificationsList = (props: NotificationsListProps): ReactElement => (
    <ul className="MobileNotificationsList">
        <NotificationsPopupTabbedContent {...props} />
    </ul>
);

const MobileNotificationsSheet = () => {
    const notificationSheetProps = useSheet(SheetId.Notifications);

    return (
        <SheetContainer
            {...notificationSheetProps}
            className="MobileNotificationsSheet"
            defaultSnapPoint={1}
            snapPoints={[0.5, 1]}
        >
            <Sheet>
                <Header>
                    <Heading>Notifications</Heading>
                    <CloseButton />
                </Header>

                <Content>
                    <NotificationsContent ContentComponent={MobileNotificationsList} />
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileNotificationsSheet;
